import { render, staticRenderFns } from "./payDialog.vue?vue&type=template&id=12d3e742"
import script from "./payDialog.vue?vue&type=script&lang=js"
export * from "./payDialog.vue?vue&type=script&lang=js"
import style0 from "./payDialog.vue?vue&type=style&index=0&id=12d3e742&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports